/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { BrandFetchRequest, VendorDto } from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiVendorsController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-vendors-controller
   * @name FindAll
   * @request GET:/api/v1/vendors
   */
  findAll = (params: RequestParams = {}) =>
    this.http.request<VendorDto[], any>({
      path: `/v1/vendors`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static findAllPath = '/v1/vendors'
  static findAllMethod = 'GET'
  /**
   * No description
   *
   * @tags api-vendors-controller
   * @name FindByVendorName
   * @request POST:/api/v1/vendors
   */
  findByVendorName = (data: BrandFetchRequest, params: RequestParams = {}) =>
    this.http.request<VendorDto, any>({
      path: `/v1/vendors`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static findByVendorNamePath = '/v1/vendors'
  static findByVendorNameMethod = 'POST'
  /**
   * No description
   *
   * @tags api-vendors-controller
   * @name FindById2
   * @request GET:/api/v1/vendors/{id}
   */
  findById = (id: string, params: RequestParams = {}) =>
    this.http.request<VendorDto, any>({
      path: `/v1/vendors/${id}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static findByIdPath = '/v1/vendors/${id}'
  static findByIdMethod = 'GET'
}
